import React from "react";
import { IIcons } from "./icons";

const ForgotModalBanner = ({ fillColor }: IIcons.IconProps) => {
  return (
    <svg
      width="385"
      height="351"
      viewBox="0 0 385 351"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={fillColor}
    >
      <ellipse cx="233.449" cy="319.014" rx="151" ry="31" fill="#7FDEFF" />
      <path
        d="M181.329 108.125L167.438 125.617L173.695 97.8571L279.493 61.0137L181.329 108.125Z"
        fill="white"
      />
      <path
        opacity="0.13"
        d="M173.669 98.0712L235.887 81.7979L180.934 108.616L167.578 125.327L173.669 98.0712Z"
        fill="#6D6E6F"
      />
      <path d="M167.438 125.617L180.975 108.364L279.22 61.252L167.438 125.617Z" fill="#3B455A" />
      <path d="M279.221 61.2516L279.493 61.0137L278.223 61.6037L279.221 61.2516Z" fill="#707F78" />
      <path
        d="M279.22 61.252L278.222 61.6041L181.028 108.245L180.918 108.283L202.108 138.022L279.22 61.252Z"
        fill="#06224B"
      />
      <path
        d="M279.491 61.0137L155.461 72.5478L173.541 97.9237L278.221 61.6037L279.491 61.0137Z"
        fill="#06224B"
      />
      <path d="M334.846 215.205L186 226.368L263.92 267.009L334.846 215.205Z" fill="#06224B" />
      <path
        d="M181.333 229.775L187.247 308.048C187.963 317.551 196.28 324.674 205.824 323.96L328.077 314.791C338.629 314.001 346.497 304.251 345.647 293.012L339.967 217.874L264.369 273.084L181.328 229.77L181.333 229.775Z"
        fill="#06224B"
      />
      <path
        d="M308.14 217.208C308.044 218.484 308.04 219.778 308.14 221.091C308.446 225.136 309.683 228.895 311.627 232.164L334.847 215.205L308.14 217.208Z"
        fill="#292949"
      />
      <path
        d="M335.644 244.649C337.822 244.487 339.919 244.054 341.902 243.393L339.972 217.879L314.707 236.327C319.837 241.961 327.433 245.263 335.639 244.649H335.644Z"
        fill="#292949"
      />
      <path
        d="M357.931 233.604C367.948 223.625 367.948 207.447 357.931 197.468C347.913 187.489 331.672 187.489 321.654 197.468C311.636 207.447 311.636 223.625 321.654 233.604C331.672 243.583 347.913 243.583 357.931 233.604Z"
        fill="#06224B"
      />
      <path
        d="M345.137 229.504L339.128 229.861L337.953 210.166L334.198 210.39L333.84 204.404L343.599 203.823L345.137 229.504Z"
        fill="white"
      />
      <path
        d="M158.7 294.984C158.251 294.741 157.272 294.732 155.867 294.884"
        stroke="#FEFFFF"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M150.266 295.783C128.832 299.737 76.5924 311.567 94.7969 257.57C116.751 192.452 170.901 242.99 78.2118 260.972C-12.3523 278.539 77.5478 160.415 153.05 128.13"
        stroke="#FEFFFF"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M155.668 127.035C156.561 126.678 157.45 126.331 158.333 125.998"
        stroke="#FEFFFF"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <circle cx="18.168" cy="159.014" r="18" fill="#7FDEFF" />
      <circle r="10.5" transform="matrix(-1 0 0 1 369.668 27.5137)" fill="#7FDEFF" />
      <circle cx="24.168" cy="121.014" r="8" fill="#7FDEFF" />
      <ellipse rx="5" ry="4.5" transform="matrix(-1 0 0 1 366.168 4.51367)" fill="#7FDEFF" />
    </svg>
  );
};

export default ForgotModalBanner;
